import React from 'react'

const Static = Component => class extends React.Component {
  shouldComponentUpdate () {
    return false
  }

  render () {
    return <Component {...this.props} />
  }
}

export default Static



// WEBPACK FOOTER //
// ./src/components/StaticComponent.js